import { render, staticRenderFns } from "./lock-unlock-folder.vue?vue&type=template&id=22b7c467"
import script from "./lock-unlock-folder.vue?vue&type=script&lang=js"
export * from "./lock-unlock-folder.vue?vue&type=script&lang=js"
import style0 from "./lock-unlock-folder.vue?vue&type=style&index=0&id=22b7c467&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports